import { SearchMakersWithFiltersSortBy } from "@faire/web-api--source/indigofair/data/SearchMakersWithFiltersSortBy";
import { SortOrder } from "@faire/web-api--source/indigofair/data/SortOrder";
import { STATE_PROVINCE_SHORTHAND_TO_NAME } from "@faire/web/common/consts/STATE_PROVINCE_SHORTHAND_TO_NAME";
import qs from "query-string";

type StateOrProvince = keyof ReturnType<
  typeof STATE_PROVINCE_SHORTHAND_TO_NAME
>;

// TODO: These query params should moved to the backend
export type QueryParameters = {
  /**
   * Open Sign In Modal
   */
  signIn?: "1";
  /**
   * Open Sign Up Modal
   */
  signUp?: "1";
  /**
   * Page Number
   */
  page?: number;
  /**
   * Maker Value: Not sold on Amazon
   */
  not_sold_on_amazon?: "true";
  /**
   * Maker Value: Made in USA
   */
  made_in_country?: "usa";
  /**
   * Maker Value: Made in Canada
   */
  made_in_canada?: "true";
  /**
   * Maker Value: Made in Europe
   */
  made_in_europe?: "true";
  /**
   * Maker Value: Handmade
   */
  hand_made?: "true";
  /**
   * Maker Value: Eco friendly
   */
  eco_friendly?: "true";
  /**
   * Maker Value: Social Good
   */
  charitable?: "true";
  /**
   * Maker Value: Women Owned
   */
  women_owned?: "true";
  /**
   * Maker Value: Organic
   */
  organic?: "true";
  /**
   * Maker Value: Small Batch
   */
  small_batch?: "true";

  /**
   * Ships from Canada
   */
  ships_from_canada?: "true";

  /**
   * Maker Specials: Free Shipping
   */
  free_shipping?: "true";
  /**
   * Maker Specials: $ Off
   */
  amount_off?: "true";
  /**
   * Maker Specials: % Off
   */
  percent_off?: "true";
  /**
   * Maker Minimum: $0, $100, $200, $300 or less
   */
  maker_minimum?: number;

  /**
   * Location: US States and Canada Provinces
   */
  based_in_state?: StateOrProvince | StateOrProvince[];

  /**
   * Faire Insider
   */
  insider?: "true";
  /**
   * SortBy
   */
  sort_by?: keyof typeof SearchMakersWithFiltersSortBy;
  /**
   * SortOrder
   */
  sort_order?: keyof typeof SortOrder;
  /**
   * Stringified filter keys
   */
  filters?: string;
};

export namespace QueryParameters {
  export const parse = (search: string): QueryParameters => {
    const queryParams = qs.parse(search) as Record<
      keyof QueryParameters,
      string
    >;
    const page = parseInt(queryParams.page, 10);
    const maker_minimum = parseInt(queryParams.maker_minimum, 10);

    return {
      ...queryParams,
      page: !Number.isNaN(page) ? page : undefined,
      maker_minimum: !Number.isNaN(maker_minimum) ? maker_minimum : undefined,
    } as QueryParameters;
  };

  export const stringify = (
    queryParams: QueryParameters,
    options: Partial<{ addQueryPrefix: boolean }> = {}
  ): string => {
    const search = qs.stringify(queryParams);
    if (search && options.addQueryPrefix) {
      return "?" + search;
    }
    return search;
  };
}
